// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./styles/archive.scss
// module id = 47
// module chunks = 4